// Copyright (c) 2022 by Move Closer

import { computed, PropType } from '@vue/composition-api'

import { ComponentObjectPropsOptions } from '../../vue-api'

import { NavProps, UseNavProvides } from './Nav.contracts'

/**
 * @author Wojciech Falkowski <wojciech.falkowski@movecloser.pl>
 */
export const navProps: ComponentObjectPropsOptions<NavProps> = {
  /**
   * Items to render.
   */
  links: {
    type: Array as PropType<NavProps['links']>,
    required: true
  }
}

export const useNav = (props: NavProps): UseNavProvides => {
  const navLinks = computed(() => props.links.map(link => {
    const { badge, badgeExpiresAt, ...baseLink } = link

    if (!badge || !badgeExpiresAt) {
      return baseLink
    }

    if (new Date(badgeExpiresAt) >= new Date()) {
      return { ...baseLink, badge }
    }

    return baseLink
  }))

  return { navLinks }
}
